import { Box, Grid, SvgIcon } from '@mui/material';

import Button from '@/components/Buttons/Button';

type Option = {
  id: string;
  label?: string;
  icon: string;
  outlined?: boolean;
  disabled?: boolean;
};

export const ExportGroup = ({
  groupName,
  GroupIcon,
  options,
  setPreviewOptionId
}: {
  groupName: string;
  GroupIcon: typeof SvgIcon;
  options: Option[];
  setPreviewOptionId: (id: string) => void;
}) => {
  return (
    <Box sx={{ my: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <GroupIcon
          fontSize='small'
          sx={{ mr: 1 }}
        />
        {groupName}
      </Box>
      <Grid
        container
        spacing={2}
      >
        {options.map(({ id, label, icon, outlined, disabled }) => (
          <ExportItem
            key={id}
            disabled={disabled}
            icon={icon}
            id={id}
            label={label}
            outlined={outlined}
            setPreviewOptionId={setPreviewOptionId}
          />
        ))}
      </Grid>
    </Box>
  );
};

const ExportItem = ({
  id,
  label,
  icon,
  outlined,
  disabled,
  setPreviewOptionId
}: {
  id: string;
  setPreviewOptionId: (id: string) => void;
  label?: string;
  icon: string;
  outlined?: boolean;
  disabled?: boolean;
}) => {
  return (
    <Grid
      size={{
        xs: 12,
        md: 12,
        lg: 4
      }}
    >
      <Button
        fullWidth
        disabled={disabled}
        size='small'
        sx={{
          height: 33,
          display: 'flex',
          justifyContent: 'flex-start',
          backgroundColor: outlined ? '' : 'secondary.main',
          '&:hover': {
            backgroundColor: outlined ? '' : 'secondary.main'
          }
        }}
        variant={outlined ? 'outlined' : 'contained'}
        onClick={() => {
          setPreviewOptionId(id);
        }}
      >
        <Box
          component='img'
          src={icon}
          sx={{ mr: 1 }}
        />
        {label}
      </Button>
    </Grid>
  );
};

export default ExportGroup;
